import { createRouter, createWebHistory, type NavigationGuard } from 'vue-router';
import { useGlobal } from '@/composables';
import type { LanguageCode } from '@/types';
import Home from '@/views/Home.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: ':locale',
          name: 'locale',
          component: Home,
        },
      ],
    },
  ],
});

const languageRedirectGuard: NavigationGuard = (to, from, next) => {
  const { language } = useGlobal();
  if (to.name === 'locale') {
    language.value = to.params.locale as LanguageCode;
    next();
  } else if (to.name === 'home') {
    next({ name: 'locale', params: { locale: language.value } });
  } else {
    next();
  }
};

router.beforeEach(languageRedirectGuard);

export default router;
